import React, { useState } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

import ConfirmDeleteModal from "../../images/ConfirmDeleteModal";
import { useCapture } from "../../../contexts/capture";
import { getAssetItemImage } from "./AssetItemImage";
import AssetItemImage from "./AssetItemImage";
import AssetItemDescription from "./AssetItemDescription";
import { formRef } from "../../../views/capture/Form";
import UnsavedChangesDialog from "../../..//components/modals/UnsavedChanges/UnsavedChangesDialog";

const styles = {
  root: ({ selected }) => ({
    display: "flex",
    justifyContent: "flex-start",
    border: "1px solid",
    borderColor: "transparent",
    borderBottomColor: "#DDDBDA",
    boxSizing: "border-box",
    background: selected ? "rgba(25, 118, 210, 0.12)" : "white",
    height: 70,
    padding: 0,
    textAlign: "left",
    maxWidth: "100%",
    overflow: "hidden",
    borderRadius: 0,
    textTransform: "none",
  }),
};

export default function AssetItem({
  currentAsset,
  setCurrentAsset,
  onRemove,
  onOpenImageModal,
  asset,
  onSelectImage,
  bulkProps,
}) {
  const { order } = useCapture();
  const [deleteAsset, setDeleteAsset] = useState(false);
  const [unsavedChangesModal, setUnsavedChangesModal] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const selected = currentAsset?.id === asset.id;
  const Checkbox = bulkProps.component;

  const handleDelete = async () => {
    try {
      await onRemove({
        variables: {
          id: asset.id,
          projectId: asset.projectId,
        },
      });
    } catch (error) {
      console.error("Failed to delete asset:", error);
    }
  };

  const handleToggleConfirmDeleteModal = () => setDeleteAsset(prev => !prev);

  const handleImageClick = e => {
    e.stopPropagation();
    const image = getAssetItemImage(asset?.images);

    if (
      currentAsset?.id &&
      currentAsset.id !== asset.id &&
      formRef?.current?.dirty
    ) {
      setPendingAction("image");
      setUnsavedChangesModal(true);
      return;
    }

    setCurrentAsset(asset);
    if (image) {
      onSelectImage(image.id);
      onOpenImageModal(asset.id);
    }
  };

  const handleSelectAsset = () => {
    if (
      currentAsset?.id &&
      currentAsset.id !== asset.id &&
      formRef?.current?.dirty
    ) {
      setPendingAction("select");
      setUnsavedChangesModal(true);
      return;
    }

    setCurrentAsset(asset);
  };

  const handleCloseUnsavedChangesModal = () => {
    setUnsavedChangesModal(false);
    setPendingAction(null);
  };

  const handleConfirmDiscardChanges = () => {
    handleCloseUnsavedChangesModal();

    if (pendingAction === "image") {
      const image = getAssetItemImage(asset?.images);
      setCurrentAsset(asset);
      if (image) {
        onSelectImage(image.id);
        onOpenImageModal(asset.id);
      }
    }

    if (pendingAction === "select") {
      setCurrentAsset(asset);
    }
  };

  const handleSaveChanges = () => {
    const saveButton = document.querySelector("#saveAsset");
    if (saveButton) {
      saveButton.click();
    }
    handleConfirmDiscardChanges();
  };

  return (
    <>
      <Box>
        <Button
          id={`assetItem-${asset.id}`}
          fullWidth
          sx={styles.root({ selected })}
          variant="text"
          onClick={handleSelectAsset}
          aria-selected={selected}
          role="option"
        >
          <Checkbox entity={asset} />
          <AssetItemImage ml={2} images={asset.images} onClick={handleImageClick} />
          <AssetItemDescription asset={asset} order={order} />
        </Button>
      </Box>
      {deleteAsset && (
        <ConfirmDeleteModal
          title="Delete Asset"
          descr="Are you sure you want to delete asset?"
          onClose={handleToggleConfirmDeleteModal}
          onDelete={handleDelete}
        />
      )}
      {unsavedChangesModal && (
        <UnsavedChangesDialog
          open={unsavedChangesModal}
          onCancel={handleCloseUnsavedChangesModal}
          onDiscard={handleConfirmDiscardChanges}
          onSave={handleSaveChanges}
        />
      )}
    </>
  );
}
